import React from "react";
import { useSelector } from "react-redux";
import Logo from "../../assets/Logo";

export default function PrintExportHeader({ title = "Healthcare Intelligence Report", subtitle }) {
  const me = useSelector((state) => state.me?.me || {});
  const doctorName =
    me.fullName || me.name || me.doctor_name || `${me.given_name || ""} ${me.family_name || ""}`.trim() || "Clinician";
  const clinicName = me.clinicName || me.clinic_name || "Healthcare Partner Practice";

  return (
    <div className="print-header hidden print:flex flex-col gap-2 border-b-2 border-blue-600 pb-4 mb-6">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <Logo size="medium" />
          <div>
            <h1 className="text-xl font-bold text-gray-900 tracking-tight">
              Seismic Connect
            </h1>
            <p className="text-xs font-semibold text-blue-600 uppercase tracking-wider">
              Healthcare Intelligence Platform
            </p>
          </div>
        </div>
        <div className="text-right text-xs text-gray-500 space-y-0.5">
          <p className="font-medium text-gray-800">{clinicName}</p>
          <p>Provider: Dr. {doctorName}</p>
          <p>Generated: {new Date().toLocaleString()}</p>
        </div>
      </div>
      <div className="bg-slate-50 p-3 rounded border border-slate-200 mt-1 flex justify-between items-center">
        <span className="font-semibold text-sm text-slate-800">{title}</span>
        {subtitle && <span className="text-xs text-slate-600">{subtitle}</span>}
      </div>
    </div>
  );
}
